/* eslint-disable */
import React, { Component } from 'react';
import moment from 'moment';
import Tooltip from '../../common/Tooltip';
import Loader from '../../common/LoadingSpinner';
import * as api from '../../../epics/api';

export default class SelectTimePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: moment(this.props.value),
            selectedTime: moment(this.props.value).toISOString(),
            apiFieldName: this.props.apiFieldName,
            changingTime: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: moment(nextProps.value),
            selectedTime: moment(nextProps.value).toISOString(),
            apiFieldName: nextProps.apiFieldName,
        });
    }

    handleChange(event) {
        const self = this;
        this.setState({ changingTime: true });
        const selectedDateTime = event.target.value;
        const { apiFieldName } = this.state;
        const fieldName =
            apiFieldName === 'datetime_started' ? 'start' : 'finish';
        const data = {};
        data[apiFieldName] = selectedDateTime;

        const response = api.executeHttpRequest(
            `jobs/${this.props.jobId}/bookings/${this.props.bookingId}/`,
            'patch',
            data,
        );
        response.then(res => {
            self.setState({
                selectedTime: selectedDateTime,
                changingTime: false,
            });
            // Referesh the table
            self.props.table.table.fireFetchData();
            self.props.notification.success(
                'Success',
                `The ${fieldName} time of this booking has been successfully updated.`,
            );
        });
        response.catch(err => {
            self.setState({
                changingTime: false,
            });
            self.props.notification.error(
                'Error',
                `The ${fieldName} time of this booking could not be updated.`,
            );
        });
    }

    getTimeOptions() {
        const timeOptions = [];
        let time;
        let k = 0;
        for (let i = -12; i <= 12; i++) {
            time = moment(this.state.selectedTime).add(i * 15, 'minutes');
            k++;
            timeOptions.push(
                <option key={k} value={time.toISOString()}>
                    {time.format('HH:mm')}
                </option>,
            );
        }
        return timeOptions;
    }

    render() {
        if (this.state.changingTime) {
            return <Loader color="gray" size="10px" className="x-small" />;
        }
        if (this.props.tooltipMessage) {
            return (
                <Tooltip tooltip={this.props.tooltipMessage}>
                    <select
                        className="select-time"
                        value={this.state.selectedTime}
                        onChange={this.handleChange}
                        style={{ color: this.props.color }}
                    >
                        {this.getTimeOptions()};
                    </select>
                </Tooltip>
            );
        }
        return (
            <select
                className="select-time"
                value={this.state.selectedTime}
                onChange={this.handleChange}
                style={{ color: this.props.color }}
            >
                {this.getTimeOptions()};
            </select>
        );
    }
}
